import { useLang } from "@/context/LanguageContext";

const CLS = {
  "EN ATTENTE DE PAIEMENT": "bg-orange-50 text-orange-700 border-orange-200",
  PAYEE: "bg-emerald-50 text-emerald-700 border-emerald-200",
  "EN COURS DE PRODUCTION": "bg-amber-50 text-amber-700 border-amber-200",
  LIVREE: "bg-blue-50 text-blue-700 border-blue-200",
};

export const StatusBadge = ({ status }) => {
  const { st } = useLang();
  const cls = CLS[status] || "bg-neutral-100 text-neutral-700 border-neutral-200";
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center gap-1.5 rounded-full border px-3 py-1 text-xs font-semibold uppercase tracking-wide ${cls}`}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current" />
      {st(status)}
    </span>
  );
};
